import { NavLink } from "react-router-dom";
import { Bell, Home, UserCircle, Users } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { useNavItems } from "./Sidebar";

// Show 4 primary items on mobile per role.
const STAFF_MOBILE_KEYS = new Set(["Dashboard", "Directory", "Notifications", "My Profile"]);
const VOLUNTEER_MOBILE_KEYS = new Set(["Dashboard", "My Trainings", "Resources", "My Profile"]);

export function MobileNav() {
  const { user } = useAuth();
  const keys = user?.role === "volunteer" ? VOLUNTEER_MOBILE_KEYS : STAFF_MOBILE_KEYS;
  const items = useNavItems().filter((n) => keys.has(n.label));
  return (
    <nav
      className="fixed bottom-0 inset-x-0 z-40 lg:hidden border-t border-sage-300 bg-cream-100/95 backdrop-blur"
      data-testid="mobile-bottom-nav"
    >
      <ul className="grid grid-cols-4">
        {items.map(({ to, label, icon: Icon, testId }) => (
          <li key={to}>
            <NavLink
              to={to}
              end={to === "/"}
              data-testid={`m-${testId}`}
              className={({ isActive }) =>
                `flex flex-col items-center gap-1 py-2 text-xs font-medium transition-colors ${
                  isActive ? "text-forest-600" : "text-charcoal-soft"
                }`
              }
            >
              <Icon className="h-5 w-5" strokeWidth={1.5} />
              <span>{label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
